import React from "react";
import { Skeleton } from "@picklebet/ui";
import * as styles from "./AddCardFormSkeleton.module.scss";

export const AddCardFormSkeleton = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.fieldGroup}>
        <Skeleton className={styles.label} span="half" />
        <Skeleton className={styles.input} />
      </div>

      <div className={styles.fieldGroup}>
        <Skeleton className={styles.label} span="half" />
        <Skeleton className={styles.input} />
      </div>

      <div className={styles.fieldGroup}>
        <Skeleton className={styles.label} span="half" />
        <Skeleton className={styles.input} />
      </div>

      <Skeleton className={styles.button} />
    </div>
  );
};
